import i18next from "@app/app/services/i18n";
import { CheckoutSessionProvider } from "@app/checkout/components/CheckoutSessionProvider";
import { LoyaltyContextProvider } from "@app/loyalty/context/LoyaltyContextProvider";
import { PaymentProvider } from "@app/payment/components/PaymentProvider";
import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { FormProvider, useForm } from "react-hook-form";
import { I18nextProvider } from "react-i18next";
import { QueryClientProvider } from "react-query";

import { ActiveBookingContextProvider } from "../context/ActiveBookingContextProvider";
import { AppStateContextProvider } from "../context/AppStateContextProvider";
import { IBookingEngineStateContext } from "../context/BookingEngineStateContext";
import { BookingEngineStateProvider } from "../context/BookingEngineStateProvider";
import { ErrorBoundaryProvider } from "../context/ErrorBoundaryProvider";
import { PropertyContextProvider } from "../context/PropertyContextProvider";
import { queryClient } from "../services/queryClient";
import { IBookingEngineState } from "../types";
import { ErrorFallback } from "./ErrorFallback";
import { RouterProvider } from "./router/RouterContext";
import { Routes } from "./Routes";
import { ThemeProvider } from "./ThemeProvider";

export function App() {
    const methods = useForm<IBookingEngineState>({ mode: "onSubmit" });
    const ref = React.useRef<IBookingEngineStateContext>();

    return (
        <div bablic-exclude="">
            <QueryClientProvider client={queryClient}>
                <PropertyContextProvider>
                    <ThemeProvider defaultTheme="light" storageKey="hc-ibe-theme">
                        <AppStateContextProvider>
                            <I18nextProvider i18n={i18next}>
                                <FormProvider {...methods}>
                                    <ErrorBoundaryProvider>
                                        <ActiveBookingContextProvider>
                                            <BookingEngineStateProvider ref={ref}>
                                                <PaymentProvider>
                                                    <LoyaltyContextProvider>
                                                        <ErrorBoundary FallbackComponent={ErrorFallback}>
                                                            <RouterProvider routeElements={Routes}>
                                                                {(Cmp) => <CheckoutSessionProvider>{Cmp}</CheckoutSessionProvider>}
                                                            </RouterProvider>
                                                        </ErrorBoundary>
                                                    </LoyaltyContextProvider>
                                                </PaymentProvider>
                                            </BookingEngineStateProvider>
                                        </ActiveBookingContextProvider>
                                    </ErrorBoundaryProvider>
                                </FormProvider>
                            </I18nextProvider>
                        </AppStateContextProvider>
                    </ThemeProvider>
                </PropertyContextProvider>
            </QueryClientProvider>
        </div>
    );
}
